import _ from "lodash";
import client from "lib/apolloClient/client";

import {
  getCourseGradingConfigQuery,
  getGradingPeriodsQuery,
  getMultiSubjectsGradingConfigQuery,
  getMYPIBDefinedGradeScalesQuery,
  getOrganizationGradesQuery,
  getOrganizationSubjectsQuery,
} from "./GradingSetupV2Queries";
import { MYP_IB_DEFINED, SCORE_BASED } from "Constants/stringConstants";

const getGradingConfigTypesFilter = () => {
  const types = [SCORE_BASED];

  return types;
};

export const readOrganizationSubjectsInCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationSubjectsQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const readOrganizationGradesInCache = ({ id, gradeFilters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationGradesQuery,
      variables: {
        id,
        gradeFilters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const readGradingPeriodsFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getGradingPeriodsQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null)
    return _.map(_.get(queryData, "node.gradingPeriods.edges", {}), "node");
  else return {};
};

export const getCourseGradingConfigQueryFromCache = ({ learningCourseId }) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getCourseGradingConfigQuery,
      variables: {
        id: learningCourseId,
        filters: {
          type: getGradingConfigTypesFilter(),
        },
      },
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const getMultiSubjectsGradingConfigQueryFromCache = ({
  subjectIds,
  primaryGradeId,
  academicYearId,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getMultiSubjectsGradingConfigQuery,
      variables: {
        ids: subjectIds,
        filters: {
          gradeIds: [primaryGradeId],
          type: getGradingConfigTypesFilter(),
          academicYearId,
        },
        gradingMethodologyFilters: {
          gradeIds: [primaryGradeId],
          academicYearId,
        },
      },
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "multiNode", []);
};

export const readMYPIBDefinedGradeScaleFromCache = ({
  curriculumProgramId,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getMYPIBDefinedGradeScalesQuery,
      variables: {
        id: curriculumProgramId,
        filters: {
          isArchived: false,
          types: MYP_IB_DEFINED,
          entityType: "CURRICULUM_PROGRAM",
          entityDetailFilters: [
            {
              curriculumProgramId,
            },
          ],
        },
        gradeScaleEntityDetailsFilters: {
          entityType: "CURRICULUM_PROGRAM",
          entityDetails: [
            {
              curriculumProgramId,
            },
          ],
        },
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null)
    return _.get(queryData, "node.gradeScale.edges.0.node", {});
  else return {};
};
